import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { CameraService } from '@services/camera.service';

@Component({
    selector: 'app-camera',
    templateUrl: './camera.component.html',
    styleUrls: ['./camera.component.scss'],
})
export class CameraModalComponent implements OnInit, AfterContentInit {

    public Title: string = "";

    public OverlayQRCode: boolean = false;
    public EnableUI: boolean = false;
    public CanClose: boolean = true;
    private cameraAlertLoaded: Function;


    public IsCompleted: boolean = false;
    
    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private Platform: Platform,
        private CameraService: CameraService
    ) {

        this.Title = this.NavParams.get('title') || '';
        this.OverlayQRCode = this.NavParams.get('overlayQRcode') ?? false;
        this.EnableUI = this.NavParams.get('enableUI') ?? false;
        this.CanClose = this.NavParams.get('canClose') ?? true;
        this.cameraAlertLoaded = this.NavParams.get('cameraAlertLoaded') ?? null;

        const isInStandaloneMode = () =>
            'standalone' in window.navigator && window.navigator['standalone'];

        if (this.Platform.is('ios') && isInStandaloneMode()) {
            console.log('I am a an iOS PWA!');
            // E.g. hide the scan functionality!
        }
    }

    async ngOnInit() {

    }
    async ngAfterContentInit() {

        try {

            const { error, status } = await this.CameraService.CameraPermissions();

            this.IsCompleted = status;

            if (!status)
                this.ModalController.dismiss({ error: error }, EnumGenericRoleActionAlerts.Error);


        } catch (error) {

            console.log(error);

            this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Error);

        }

        // this.IsCompleted = true;



    }



    Close() {

        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

    /**
     * 
     * @param ev 
     */
    async OnGetImage(ev: { blob: string, text: string, base64?: string }) {


        this.ModalController.dismiss({ text: ev?.text, blob: ev?.blob, base64: ev?.base64 }, ev?.blob ? EnumGenericRoleActionAlerts.Confirm : EnumGenericRoleActionAlerts.Error);

    }

    async OnCameraLoaded(ev: { isAvailable: boolean } | any) {
        console.log(ev);

        if (ev && this.cameraAlertLoaded) {
            const r = await this.cameraAlertLoaded(ev);

            console.log(r);


            // if (!ev?.isAvailable)
            //     this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Error);
        }

    }

}
